import { UploadError } from '../../../../constants/UploadError';
import { contains, pathOr } from 'ramda';

const PremiumErrors = [
  UploadError.QuotaSingleVideoDurationExceeded,
  UploadError.QuotaTotalVideoDurationExceeded,
  UploadError.QuotaTotalStorageExceeded,
  UploadError.QuotaFreeVideoDurationExceeded,
];

export const isPremiumError = (error) => {
  return contains(pathOr(error, ['data', 'error_info', 'key'])(error), PremiumErrors);
};
